import {
  SET_CHART_CONNECT_NULLS,
  SET_CHART_TYPE,
  SET_CHART_ZOOM_FETCH,
  SET_CHART_ENERGY_TYPE
} from '../constants/actionTypes';

export const setChartType = payload => {
  return {
    type: SET_CHART_TYPE,
    payload
  };
};

export const setChartFetchOnZoom = payload => {
  return {
    type: SET_CHART_ZOOM_FETCH,
    payload
  };
};

export const setChartConnectNulls = payload => {
  return {
    type: SET_CHART_CONNECT_NULLS,
    payload
  };
};

export const setChartEnergyTypes = payload => {
  return {
    type: SET_CHART_ENERGY_TYPE,
    payload
  };
};



// WEBPACK FOOTER //
// ./src/actions/chartsOptions.js